import React from 'react';
import PropTypes from 'prop-types';

// Only Tabs
export const Tabs = ({ dataTabs, setVisibleTab, activeTab }) => {
  return (
    <div className="mz-tabs">
      <div className="mz-tabs-menu">
        {
          dataTabs.map((item) =>
            <a
              onClick={() => setVisibleTab(item.id)}
              key={item.id}
              className={`mz-tabs-tab interactive ${activeTab === item.id ? 'active' : ''}`}
            >
              {item.tabTitle}
            </a>
          )
        }
      </div>
    </div>
  );
}

Tabs.propTypes = {
  dataTabs: PropTypes.array.isRequired,
  setVisibleTab: PropTypes.func,
  activeTab: PropTypes.string.isRequired,
}

Tabs.defaultProps = {
  dataTabs: [],
}